import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import ChatsService from '../../controllers/ChatController';
import { closeConversationByAgent } from '../../redux/interactionsSlice';
import Toastr from '../utils/toastr';

class LinkConfirmation extends Component {

    constructor(props) {
        super(props)
        this.toastrRef = React.createRef();
        this.linkEmails = this.linkEmails.bind(this);
    }

    linkEmails() {

        ChatsService.linkEmails({
            "currentId": this.props.current.id,
            "historyId": this.props.currentHistory.conversationId
        }, res => {
            this.props.toggleModal();
            if (res !== "ok") {
                this.toastrRef.current.setType("error");
                this.toastrRef.current.setMessage(this.props.t(res));
                this.toastrRef.current.show();
            } else {
                this.toastrRef.current.setType("success");
                this.toastrRef.current.setMessage(this.props.t("wassavedsuccessfully"));
                this.toastrRef.current.show();
            }
            console.log(res.data);
        });
        
    }

    render() {

        return (<>
            <Modal show={this.props.show} onHide={this.props.toggleModal} size="md" backdrop="static">
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={duotone("warning")} /> {this.props.t("warning")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <p>{this.props.t("youareabouttolinkemails")}</p>
                            <p>{this.props.t("areyousure")}</p>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.linkEmails}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toastr ref={this.toastrRef} />
        </>
        )

    }
}


const mapStateToProps = (state) => {
    return {
        chatUrl: state.parameters.chatUrl,
        LOADING_TYPE: state.parameters.LOADING_TYPE,
        agentName: state.agent.name,
        userId: state.agent.userId,
        showSearch: state.interaction.showSearch,
        current: state.interaction.current,
        currentHistory: state.interaction.currentHistory,
    };
};
export default compose(connect(mapStateToProps, { closeConversationByAgent }), withTranslation())(LinkConfirmation);